// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .skeleton--2MsG1{display:flex;align-items:center;justify-content:center;width:100%;height:var(--skeleton-height,1em)}.precise-price-app .skeleton__content--2NnM4{width:var(--skeleton-width,5em);height:var(--skeleton-font-size,var(--font-size));font-size:var(--skeleton-font-size,inherit);background-color:var(--skeleton-color,rgba(0,0,0,.1));border-radius:1em}", ""]);
// Exports
exports.locals = {
	"skeleton": "skeleton--2MsG1",
	"skeletonContent": "skeleton__content--2NnM4"
};
module.exports = exports;
